import React from 'react';

import i18n from 'i18n';

import './AccountSummary.scss';

import { AccountSummaryProps } from './AccountSummaryModel';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { hasRoles } from 'core/permission/PermissionDSL';
import { RoleNames } from 'core';

export class AccountSummary extends React.Component<AccountSummaryProps> {
  render () {
    const model = this.props.model;
    return (
      <div className='account-summary'>
        <div className='summary-row'>
          <div className='summary-column'>
            <div className='summary-label'>{i18n.t<string>(model.emailLabel)}</div>
            <div className='summary-value'>{model.email}</div>
          </div>
          <div className='summary-column'>
            <div className='summary-label'>{i18n.t<string>(model.statusLabel)}</div>
            <div className='summary-value'>{i18n.t<string>(model.status)}</div>
          </div>
          <PermissionChecker permissionAware={hasRoles(RoleNames.sysAdmin)}>
            <div className='summary-column'>
              <div className='summary-label'>{i18n.t<string>(model.isAdminLabel)}</div>
              <div className='summary-value'>{i18n.t<string>(model.isAdmin)}</div>
            </div>
          </PermissionChecker>
          <div className='summary-column'>
            <div className='summary-label'>{i18n.t<string>('accounts.summary.labels.isPending')}</div>
            <div className='summary-value'>{model.isPending.toString()}</div>
          </div>
        </div>
      </div>
    );
  }
}
